"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerCompanyMemberRole = void 0;
var CustomerCompanyMemberRole;
(function (CustomerCompanyMemberRole) {
    CustomerCompanyMemberRole["LIMITED_ACCESS"] = "limited_access";
    CustomerCompanyMemberRole["FULL_ACCESS"] = "full_access";
    CustomerCompanyMemberRole["OWNER"] = "owner";
})(CustomerCompanyMemberRole = exports.CustomerCompanyMemberRole || (exports.CustomerCompanyMemberRole = {}));
